/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';

import {
     DatabaseAudioPageBlockFromJSONTyped,
     DatabaseBannerPageBlockFromJSONTyped,
     DatabasePageBlockFromJSONTyped,
     DatabaseNamePageBlockFromJSONTyped,
     DatabaseTeaserImagePageBlockFromJSONTyped,
     DatabaseTitlePageBlockFromJSONTyped,
     DatabaseEingabelistePageBlockFromJSONTyped,
     DatabaseFieldPageBlockFromJSONTyped,
     DatabaseImagePageBlockFromJSONTyped,
     DatabaseImageListPageBlockFromJSONTyped,
     DatabaseMapPageBlockFromJSONTyped,
     DatabaseNewsletterPageBlockFromJSONTyped,
     DatabaseSubDbListPageBlockFromJSONTyped,
     DatabaseSubDbTablePageBlockFromJSONTyped,
     DatabaseTextPageBlockFromJSONTyped,
     DatabaseVideoPageBlockFromJSONTyped
} from './';

/**
 * 
 * @export
 * @interface DatabasePageBlock
 */
export interface DatabasePageBlock {
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    blockType?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    slot?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    inlineStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    backgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    link?: string;
    /**
     * Field ID that might override the content
     * @type {string}
     * @memberof DatabasePageBlock
     */
    overrideBy?: string;
    /**
     * 
     * @type {DatabasePageBlockActionType}
     * @memberof DatabasePageBlock
     */
    action?: DatabasePageBlockActionType;
    /**
     * Meldung, die POPUP/UNSUBSCRIBE nach dem Klick zeigen
     * @type {string}
     * @memberof DatabasePageBlock
     */
    actionContent?: string;
    /**
     * Vor der Aktion die Eingaben des aktuellen Datensatzes speichern.
     * Sonst wird in der Karte NUR beim Seitenwechsel gespeichert — ein
     * Knopf „Absenden" ohne diesen Schalter zeigt eine Bestaetigung an,
     * ohne dass etwas gespeichert waere.
     * @type {boolean}
     * @memberof DatabasePageBlock
     */
    saveBeforeAction?: boolean;
    /**
     * 
     * @type {Array<DatabaseFieldVisibilityRule>}
     * @memberof DatabasePageBlock
     */
    visibilityRules?: Array<DatabaseFieldVisibilityRule>;
    /**
     * ZUM AUFKLAPPEN. Der Baustein zeigt zunaechst nur eine Zeile mit
     * seinem NAMEN und einem Pfeil; erst ein Tipp darauf gibt den Inhalt
     * frei.
     * 
     * WOFUER: Auf einer Karte ist Platz das knappste Gut. Der Bahn-Tipp
     * der Minigolf-Scorecard („Tipp fuer diese Bahn") gehoert auf die
     * Spielseite, darf aber nicht die Spielerzeilen verdraengen — wer
     * ihn braucht, klappt ihn auf.
     * 
     * DER NAME IST DIE BESCHRIFTUNG. Ein eigenes Feld dafuer waere ein
     * zweiter Ort fuer dieselbe Sache; der Name steht in der Maske
     * ohnehin ganz oben. Ohne Namen steht dort „Mehr".
     * @type {boolean}
     * @memberof DatabasePageBlock
     */
    einklappbar?: boolean;
    /**
     * Zustand beim Aufschlagen der Seite: zu (Vorgabe) oder offen. Nur
     * mit `einklappbar` von Bedeutung.
     * @type {boolean}
     * @memberof DatabasePageBlock
     */
    eingeklappt?: boolean;
    /**
     * 
     * @type {DatabaseKlappzeile}
     * @memberof DatabasePageBlock
     */
    klappzeile?: DatabaseKlappzeile;
    /**
     * Nur bei `klappzeile: BALKEN_FARBE`: die Farbe des Streifens links.
     * Ohne Angabe die Schriftfarbe des Bausteins.
     * @type {string}
     * @memberof DatabasePageBlock
     */
    klappzeileFarbe?: string;
    /**
     * DIE KLAPPZEILE ALS PILLE (Vorgabe des Betreibers, 16.09.2026:
     * „Bitte in eine Pille mit duennem Rahmen setzen, der Hintergrund
     * ist transparent.").
     * 
     * Statt einer schlichten Zeile mit Name und Pfeil steht dann eine
     * runde Umrandung um die Beschriftung — so breit wie ihr Text, nicht
     * wie der Baustein. Auf der Spielkarte ist das „Infos zur Bahn »"
     * unter der Bahnnummer.
     * 
     * NUR DIE FORM AENDERT SICH: Farbe und Schrift kommen weiter vom
     * Baustein; ohne eigene Rahmenfarbe ist der Rand die Schriftfarbe,
     * der Grund bleibt durchsichtig. Nur mit `einklappbar` von
     * Bedeutung.
     * @type {boolean}
     * @memberof DatabasePageBlock
     */
    kopfAlsPille?: boolean;
}

/**
 * Check if a given object implements the DatabasePageBlock interface.
 */
export function instanceOfDatabasePageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabasePageBlockFromJSON(json: any): DatabasePageBlock {
    return DatabasePageBlockFromJSONTyped(json, false);
}

export function DatabasePageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['blockType'] === 'AUDIO') {
            return DatabaseAudioPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'BANNER') {
            return DatabaseBannerPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'BASE') {
            return DatabasePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'DB_NAME') {
            return DatabaseNamePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'DB_TEASER_IMAGE') {
            return DatabaseTeaserImagePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'DB_TITLE') {
            return DatabaseTitlePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'EINGABELISTE') {
            return DatabaseEingabelistePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'FIELD') {
            return DatabaseFieldPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'IMAGE') {
            return DatabaseImagePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'IMAGE_LIST') {
            return DatabaseImageListPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'MAP') {
            return DatabaseMapPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'NEWSLETTER') {
            return DatabaseNewsletterPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'SUB_DB_LIST') {
            return DatabaseSubDbListPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'SUB_DB_TABLE') {
            return DatabaseSubDbTablePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'TEXT') {
            return DatabaseTextPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'VIDEO') {
            return DatabaseVideoPageBlockFromJSONTyped(json, true);
        }
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'blockType': !exists(json, 'blockType') ? undefined : json['blockType'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'slot': !exists(json, 'slot') ? undefined : json['slot'],
        'inlineStyle': !exists(json, 'inlineStyle') ? undefined : json['inlineStyle'],
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'link': !exists(json, 'link') ? undefined : json['link'],
        'overrideBy': !exists(json, 'overrideBy') ? undefined : json['overrideBy'],
        'action': !exists(json, 'action') ? undefined : DatabasePageBlockActionTypeFromJSON(json['action']),
        'actionContent': !exists(json, 'actionContent') ? undefined : json['actionContent'],
        'saveBeforeAction': !exists(json, 'saveBeforeAction') ? undefined : json['saveBeforeAction'],
        'visibilityRules': !exists(json, 'visibilityRules') ? undefined : ((json['visibilityRules'] as Array<any>).map(DatabaseFieldVisibilityRuleFromJSON)),
        'einklappbar': !exists(json, 'einklappbar') ? undefined : json['einklappbar'],
        'eingeklappt': !exists(json, 'eingeklappt') ? undefined : json['eingeklappt'],
        'klappzeile': !exists(json, 'klappzeile') ? undefined : DatabaseKlappzeileFromJSON(json['klappzeile']),
        'klappzeileFarbe': !exists(json, 'klappzeileFarbe') ? undefined : json['klappzeileFarbe'],
        'kopfAlsPille': !exists(json, 'kopfAlsPille') ? undefined : json['kopfAlsPille'],
    };
}

export function DatabasePageBlockToJSON(value?: DatabasePageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'blockType': value.blockType,
        'id': value.id,
        'slot': value.slot,
        'inlineStyle': value.inlineStyle,
        'backgroundColor': value.backgroundColor,
        'link': value.link,
        'overrideBy': value.overrideBy,
        'action': DatabasePageBlockActionTypeToJSON(value.action),
        'actionContent': value.actionContent,
        'saveBeforeAction': value.saveBeforeAction,
        'visibilityRules': value.visibilityRules === undefined ? undefined : ((value.visibilityRules as Array<any>).map(DatabaseFieldVisibilityRuleToJSON)),
        'einklappbar': value.einklappbar,
        'eingeklappt': value.eingeklappt,
        'klappzeile': DatabaseKlappzeileToJSON(value.klappzeile),
        'klappzeileFarbe': value.klappzeileFarbe,
        'kopfAlsPille': value.kopfAlsPille,
    };
}

